import React, { useState, useEffect } from "react";
import axios from "axios";

export default function ProgramForm({ programId }) {
  const [contents, setContents] = useState([]);
  const [tournaments, setTournaments] = useState([]);
  const [showTournamentForm, setShowTournamentForm] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    content_id: "",
    image: "",
    qr_code: "",
    content_en: "",
  });

  const [newTournament, setNewTournament] = useState({
    title: "",
    content_id: "",  // add this
    description: "",
    start_date: "",
    end_date: "",
    registration_start: "",
    registration_last_date: ""
  });


  // Fetch all contents
  useEffect(() => {
    axios.get("/api/v1/content/")
      .then(res => setContents(res.data))
      .catch(err => console.error(err));
  }, []);

  // Fetch program & tournaments
  useEffect(() => {
    if (programId) {
      axios.get(`/api/v1/program/${programId}`)
        .then(res => setFormData(res.data))
        .catch(err => console.error(err));

      fetchTournaments();
    }
  }, [programId]);

  const fetchTournaments = () => {
    axios.get(`/api/v1/program/${programId}/tournament/`)
      .then(res => setTournaments(res.data))
      .catch(err => console.error(err));
  };

  // Program form change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Save program
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (programId) {
        await axios.put(`/api/v1/program/${programId}`, formData);
        alert("Program updated successfully!");
      } else {
        const res = await axios.post("/api/v1/program/", formData);
        alert(`Program created! ID: ${res.data.program_id}`);
      }
    } catch (err) {
      console.error(err);
      alert("Error saving program");
    }
  };

  // Tournament form change
  const handleTournamentChange = (e) => {
    const { name, value } = e.target;
    setNewTournament(prev => ({ ...prev, [name]: value }));
  };

  // Add tournament
  const handleAddTournament = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`/api/v1/program/${programId}/tournament/`, newTournament);
      alert("Tournament added!");
      setNewTournament({
        title: "",
        description: "",
        start_date: "",
        end_date: "",
        registration_start: "",
        registration_last_date: "",
      });
      setShowTournamentForm(false);
      fetchTournaments();
    } catch (err) {
      console.error(err);
      alert("Error adding tournament");
    }
  };

  // Delete tournament
  const handleDeleteTournament = async (id) => {
    if (!window.confirm("Delete this tournament?")) return;

    try {
      await axios.delete(`/api/v1/program/${programId}/tournament/${id}`);
      fetchTournaments();
    } catch (err) {
      console.error(err);
      alert("Error deleting tournament");
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <h2 className="card-title mb-4">
            {programId ? "Edit Program" : "Create Program"}
          </h2>

          {/* Program Form */}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>

            {/* Content selection */}
            <div className="mb-2">
              <label className="form-label">Content</label>
              <select
                className="form-select"
                name="content_id"
                value={newTournament.content_id}
                onChange={handleTournamentChange}
                required
              >
                <option value="">Select Content</option>
                {contents.map(c => (
                  <option key={c.id} value={c.id}>{c.title}</option>
                ))}
              </select>
            </div>


            <div className="mb-3">
              <label className="form-label">Content (Text/HTML)</label>
              <textarea
                className="form-control"
                name="content_en"
                value={formData.content_en}
                onChange={handleChange}
                rows={6}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Image URL</label>
              <input
                type="url"
                className="form-control"
                name="image"
                value={formData.image}
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">QR Code URL</label>
              <input
                type="url"
                className="form-control"
                name="qr_code"
                value={formData.qr_code}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary">
              {programId ? "Update Program" : "Create Program"}
            </button>
          </form>

          {/* Tournament Section */}
          {programId && (
            <>
              <hr className="my-5" />
              <h4 className="mb-3">Tournaments</h4>

              <button
                className="btn btn-success mb-3"
                onClick={() => setShowTournamentForm(!showTournamentForm)}
              >
                Add Tournament
              </button>

              {showTournamentForm && (
                <form onSubmit={handleAddTournament} className="mb-4 border p-3 rounded">
                  <div className="mb-2">
                    <input
                      className="form-control"
                      name="title"
                      placeholder="Tournament Title"
                      value={newTournament.title}
                      onChange={handleTournamentChange}
                      required
                    />
                  </div>

                  <div className="mb-2">
                    <textarea
                      className="form-control"
                      name="description"
                      placeholder="Tournament Description"
                      value={newTournament.description}
                      onChange={handleTournamentChange}
                      rows={3}
                    />
                  </div>

                  <div className="mb-2">
                    <label>Start Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="start_date"
                      value={newTournament.start_date}
                      onChange={handleTournamentChange}
                    />
                  </div>

                  <div className="mb-2">
                    <label>End Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="end_date"
                      value={newTournament.end_date}
                      onChange={handleTournamentChange}
                    />
                  </div>

                  <div className="mb-2">
                    <label>Registration Start:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="registration_start"
                      value={newTournament.registration_start}
                      onChange={handleTournamentChange}
                    />
                  </div>

                  <div className="mb-2">
                    <label>Registration End:</label>
                    <input
                      type="date"
                      className="form-control"
                      name="registration_last_date"
                      value={newTournament.registration_last_date}
                      onChange={handleTournamentChange}
                    />
                  </div>

                  <button type="submit" className="btn btn-primary btn-sm">
                    Save Tournament
                  </button>
                </form>
              )}

              {/* Tournament List */}
              <ul className="list-group">
                {tournaments.map(t => (
                  <li
                    key={t.id}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span>
                      {t.title} — {t.start_date} to {t.end_date}
                    </span>

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteTournament(t.id)}
                    >
                      Delete
                    </button>
                  </li>
                ))}
              </ul>
            </>
          )}

        </div>
      </div>
    </div>
  );
}
